import { useEffect, useState } from "react";
import backgroundVideo from "../images/homepage.mp4";
import "./Merch.css";

export default function Merch({ addToCart}) {
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    //verify cart is syncing with localStorage across tabs



    const gridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: "20px",
        paddingBottom: "40px"
    };

    const cardStyle = {
        border: "1px solid rgba(255,255,255,0.15)",
        borderRadius: "10px",
        padding: "16px",
        background: "rgba(0,0,0,0.45)",
        WebkitBackdropFilter: "blur(10px)",
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
        color: "#fff"
    };

    const imageStyle = {
        width: "100%",
        height: "150px",
        objectFit: "cover",
        borderRadius: "8px",
        display: "block"
    };

    const buttonStyle = {
        marginTop: "10px",
        width: "100%",
        padding: "8px",
        background: "#000",
        color: "#fff",
        border: "none",
        cursor: "pointer"
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            let url = "https://high-and-fly-1.onrender.com/api/contact/product/list/";

            if (search.trim()) {
                url += `?search=${encodeURIComponent(search)}`;
            }

            fetch(url)
                .then((res) => res.json())
                .then((data) => setProducts(data))
                .catch((err) => console.error("Error loading products:", err));
        }, 300);

        return () => clearTimeout(timer);
    }, [search]);
    const filteredProducts = products.filter(p => p.origin === "HighnFly");

    return (
        <div className="page">
            <video autoPlay loop muted playsInline className="background-video">
                <source src={backgroundVideo} type="video/mp4" />
            </video>

            <div className="content_in">
                <h1>Store</h1>

                <input
                    type="text"
                    placeholder="Search products..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "100%",
                        maxWidth: "400px",
                        marginBottom: "20px",
                        borderRadius: "8px",
                        border: "1px solid #ccc"
                    }}
                />

                <div style={gridStyle}>
                    {filteredProducts.map((product) => (
                        <div key={product.id} style={cardStyle}>
                            {product.image && (
                                <img
                                    src={`https://high-and-fly-1.onrender.com${product.image}`}
                                    alt={product.name}
                                    style={imageStyle}
                                />
                            )}

                            <h3>{product.name}</h3>
                            <p>{product.description}</p>

                            <div style={{ marginTop: "10px" }}>
                                <strong>${product.price}</strong>
                            </div>

                            <div>Category: {product.category}</div>
                            <div>Qty: {product.quantity}</div>

                            <button 
                              style={buttonStyle}
                              onClick={() => addToCart(product)}
                            >
                                Add to Cart
                            </button>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}
